import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import ValidationIdErrorView from '../../../components/views/mx/creditoReal/ValidationIdErrorView';
import {State} from '../../../types/mx/reducers';

const mapStateToProps = (state: State) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {};
};

const ValidationIdErrorContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ValidationIdErrorView);

export default ValidationIdErrorContainer;
